export default {"src":"/_next/static/media/linkedin-icon.d35b075b.svg","height":32,"width":33};